export default "__VITE_ASSET__e6c0b578__"